export const NEW_HOME_ANNOUNCEMENT_ID = "infra-assistant-new-home-2";

export const getMainNavigationAnnouncementStorageKey = (announcementId: string) =>
  `mainNavigationAnnouncement:${announcementId}`;

export const NEW_HOME_ANNOUNCEMENT_STORAGE_KEY =
  getMainNavigationAnnouncementStorageKey(NEW_HOME_ANNOUNCEMENT_ID);
